import request from './request.js';

// 登录
export function login(data) {
    return request({
        url: '/kowert/login',
        method: 'post',
        data,
    });
}
// 获取验证码
export function getCaptcha() {
    return request({
        url: '/login/get/captcha',
        method: 'get',
    });
}
// 修改登陆密码
export function updatePassword(data) {
    return request({
        url: '/personal/center/reset/login/password',
        method: 'post',
        data,
    });
}
// 文件上传
export function oneFileUpload(data) {
    return request({
        url: '/file/upload',
        method: 'post',
        data,
    });
}
// 登陆用户管辖角色列表
export function userLoginRoleList() {
    return request({
        url: '/login/user/manageable/role/list',
        method: 'get',
    });
}
// 获取地区树
export function regionTree() {
    return request({
        url: '/region/province/city/county/tree',
        method: 'get',
    });
}

/*------------------枚举-------------------*/
// 科普内容标识
export let sciencePopularizationContentTagList = [
    {
        value: true,
        label: '是',
    },
    {
        value: false,
        label: '否',
    },
];
// 科普内容类别
export let sciencePopularizationContentTypeList = [
    {
        value: 10,
        label: '文件',
    },
    {
        value: 20,
        label: '富文本',
    },
];

/*------------------科普管理-------------------*/
// 获取动态科普菜单
export function sciencePopularizationFirstList() {
    return request({
        url: `/science/popularization/first/level/list`,
        method: 'get',
    });
}
// 获取科普
export function sciencePopularizationTree() {
    return request({
        url: `/science/popularization/tree`,
        method: 'get',
    });
}
// 新增科普
export function sciencePopularizationAdd(data) {
    return request({
        url: `/science/popularization/add`,
        method: 'post',
        data,
    });
}
// 科普详情
export function sciencePopularizationDetail(id) {
    return request({
        url: `/science/popularization/detail/${id}`,
        method: 'get',
    });
}
// 获取科普富文本信息
export function sciencePopularizationTextInfo(id) {
    return request({
        url: `/text/info/detail/${id}`,
        method: 'get',
    });
}
// 编辑科普信息
export function sciencePopularizationUpdate(data, id) {
    return request({
        url: `/science/popularization/update/${id}`,
        method: 'post',
        data,
    });
}
// 删除科普
export function sciencePopularizationDelete(id) {
    return request({
        url: `/science/popularization/delete/${id}`,
        method: 'delete',
    });
}
// 获取子级树
export function sciencePopularizationChildList(id) {
    return request({
        url: `/science/popularization/child/list/${id}`,
        method: 'get',
    });
}

/*------------------单位管理-------------------*/
// 新增单位
export function unitAdd(data) {
    return request({
        url: `/unit/add`,
        method: 'post',
        data,
    });
}
// 单位分页
export function unitPage(data) {
    return request({
        url: `/unit/page`,
        method: 'post',
        data,
    });
}
// 单位详情
export function unitDetail(id) {
    return request({
        url: `/unit/detail/${id}`,
        method: 'get',
    });
}
// 单位更新
export function unitUpdate(id, data) {
    return request({
        url: `/unit/update/${id}`,
        method: 'post',
        data,
    });
}
// 删除单位
export function unitDelete(id) {
    return request({
        url: `/unit/delete/${id}`,
        method: 'delete',
    });
}
// 单位：获取一级列表
export function unitFirstList() {
    return request({
        url: `/order/all/fist/level/department/list`,
        method: 'get',
    });
}

// 数据字典：新增
export function addSystemDict(data) {
    return request({
        url: `/system/dict/add`,
        method: 'post',
        data,
    });
}
// 数据字典：分页
export function systemDictPage(data) {
    return request({
        url: `/system/dict/page`,
        method: 'post',
        data,
    });
}
// 数据字典：详情
export function systemDictDetail(id) {
    return request({
        url: `/system/dict/detail/${id}`,
        method: 'get',
    });
}
// 数据字典：编辑
export function systemDictUpdate(id, data) {
    return request({
        url: `/system/dict/update/${id}`,
        method: 'post',
        data,
    });
}
// 数据字典：删除
export function systemDictDelete(id) {
    return request({
        url: `/system/dict/delete/${id}`,
        method: 'delete',
    });
}
// 据字典项：新增
export function addSystemDictItem(data) {
    return request({
        url: `/system/dict/item/add`,
        method: 'post',
        data,
    });
}
// 据字典项：分页
export function systemDictItemPage(dictId, data) {
    return request({
        url: `/system/dict/item/page/${dictId}`,
        method: 'post',
        data,
    });
}
// 据字典项：详情
export function systemDictItemDetail(id) {
    return request({
        url: `/system/dict/item/detail/${id}`,
        method: 'get',
    });
}
// 据字典项：编辑
export function systemDictItemUpdate(id, data) {
    return request({
        url: `/system/dict/item/update/${id}`,
        method: 'post',
        data,
    });
}
// 据字典项：删除
export function systemDictItemDelete(id) {
    return request({
        url: `/system/dict/item/delete/${id}`,
        method: 'delete',
    });
}
// 据字典项：回收分页
export function systemDictRecyclePage(data) {
    return request({
        url: `/system/dict/recycle/page`,
        method: 'post',
        data,
    });
}
// 据字典项：回收恢复
export function systemDictRecycleRecover(id) {
    return request({
        url: `/system/dict/recycle/Recover/${id}`,
        method: 'post',
    });
}
// 据字典项：查询字典项
export function dictCodeItemList(dictCode) {
    return request({
        url: `/system/dict/list/dictItem/${dictCode}`,
        method: 'get',
    });
}

/*------------------用户管理-------------------*/
// 新增用户
export function userAdd(data) {
    return request({
        url: `/user/add`,
        method: 'post',
        data,
    });
}
// 用户分页
export function userPage(data) {
    return request({
        url: `/user/page`,
        method: 'post',
        data,
    });
}
// 用户更新
export function userUpdate(id, data) {
    return request({
        url: `/user/update/${id}`,
        method: 'post',
        data,
    });
}
// 用户详情
export function userDetail(id) {
    return request({
        url: `/user/detail/${id}`,
        method: 'get',
    });
}
// 删除用户
export function userDelete(id) {
    return request({
        url: `/user/delete/${id}`,
        method: 'delete',
    });
}
// 修改用户密码
export function userUpdateLoginPassword(id, data) {
    return request({
        url: `/user/update/login/password/${id}`,
        method: 'post',
        data,
    });
}

/*------------------计量单位-------------------*/
// 新增计量单位
export function addMeteringUnit(data) {
    return request({
        url: `/goods/metering/unit/add`,
        method: 'post',
        data,
    });
}
// 计量单位列表
export function meteringUnitList() {
    return request({
        url: `/goods/metering/unit/list`,
        method: 'get',
    });
}
// 更新计量单位
export function updateMeteringUnit(id, data) {
    return request({
        url: `/goods/metering/unit/update/${id}`,
        method: 'post',
        data,
    });
}
// 删除计量单位
export function deleteMeteringUnit(id) {
    return request({
        url: `/goods/metering/unit/delete/${id}`,
        method: 'delete',
    });
}

/*------------------商品分类-------------------*/
// 新增商品分类
export function addGoodsCategory(data) {
    return request({
        url: `/goods/category/add`,
        method: 'post',
        data,
    });
}
// 获取商品分类树
export function goodsCategoryTree(data) {
    return request({
        url: `/goods/category/tree`,
        method: 'post',
        data,
    });
}
// 删除商品分类
export function deleteGoodsCategory(id) {
    return request({
        url: `/goods/category/delete/${id}`,
        method: 'delete',
    });
}
// 获取一级分类列表
export function goodsCategoryFirstLevelList(data) {
    return request({
        url: `/goods/category/first/level/list`,
        method: 'post',
        data,
    });
}
// 获取商品分类详情
export function goodsCategoryDetail(id) {
    return request({
        url: `/goods/category/detail/${id}`,
        method: 'get',
    });
}
// 更新商品分类
export function updateGoodsCategory(id, data) {
    return request({
        url: `/goods/category/update/${id}`,
        method: 'post',
        data,
    });
}
// 启用商品分类
export function enableGoodsCategory(id) {
    return request({
        url: `/goods/category/enable/${id}`,
        method: 'post',
    });
}
// 禁用商品分类
export function disableGoodsCategory(id) {
    return request({
        url: `/goods/category/disable/${id}`,
        method: 'post',
    });
}

// 品牌：新增
export function addBrand(data) {
    return request({
        url: `/brand/add`,
        method: 'post',
        data,
    });
}
// 品牌：分页
export function brandPage(data) {
    return request({
        url: `/brand/page`,
        method: 'post',
        data,
    });
}
// 品牌：详情
export function brandDetail(id) {
    return request({
        url: `/brand/detail/${id}`,
        method: 'get',
    });
}
// 品牌：更新
export function brandUpdate(id, data) {
    return request({
        url: `/brand/update/${id}`,
        method: 'post',
        data,
    });
}
// 品牌：删除
export function brandDelete(id) {
    return request({
        url: `/brand/delete/${id}`,
        method: 'delete',
    });
}

/*------------------食物-------------------*/
// 获取食物分类树
export function foodCategoryTree() {
    return request({
        url: `/food/category/tree`,
        method: 'get',
    });
}
// 获取食物列表
export function foodNutritionList(data) {
    return request({
        url: `/food/nutrition/query`,
        method: 'post',
        data,
    });
}
// 食物：通过菜谱id获取食物成分
export function foodNutritionElement(recipeId) {
    return request({
        url: `/food/nutrition/summary/data/by/recipe/${recipeId}`,
        method: 'get',
    });
}
// 食物：食物访问标签
export function foodNutritionUrl() {
    return request({
        url: `/nutrition/label/generate/weekly/menu/url`,
        method: 'get',
    });
}

/*------------------商品-------------------*/
// 新增商品
export function addGoods(data) {
    return request({
        url: `/goods/add`,
        method: 'post',
        data,
    });
}
// 商品分页
export function addGoodsPage(data) {
    return request({
        url: `/goods/page`,
        method: 'post',
        data,
    });
}
// 获取商品详情
export function goodsDetail(id) {
    return request({
        url: `/goods/detail/${id}`,
        method: 'get',
    });
}
// 商品更新
export function updateGoods(id, data) {
    return request({
        url: `/goods/update/${id}`,
        method: 'post',
        data,
    });
}
// 商品删除
export function deleteGoods(id) {
    return request({
        url: `/goods/delete/${id}`,
        method: 'delete',
    });
}
// 关联商品
export function nutritionFoodGoods(id) {
    return request({
        url: `/goods/food/nutrition/associated/list/${id}`,
        method: 'get',
    });
}
// 商品是否已复制
export function goodsIsCopy(id) {
    return request({
        url: `/goods/is/copy/judgement/${id}`,
        method: 'get',
    });
}
// 根据商品id获取食物100g营养成分
export function goodsFood100Component(goodsId) {
    return request({
        url: `/food/nutrition/summary/data/by/goods/${goodsId}`,
        method: 'get',
    });
}
// 分类id获取商品列表
export function categoryIdByGoodsList(categoryId) {
    return request({
        url: `/goods/list/by/category/${categoryId}`,
        method: 'get',
    });
}

// 菜谱分类：新增
export function cookbookCategoryAdd(data) {
    return request({
        url: `/recipe/category/add`,
        method: 'post',
        data,
    });
}
// 菜谱分类：分类树
export function cookbookCategoryTree(data) {
    return request({
        url: `/recipe/category/tree`,
        method: 'post',
        data,
    });
}
// 菜谱分类：详情
export function cookbookCategoryDetail(id) {
    return request({
        url: `/recipe/category/detail/${id}`,
        method: 'get',
    });
}
// 菜谱分类：更新
export function cookbookCategoryUpdate(id, data) {
    return request({
        url: `/recipe/category/update/${id}`,
        method: 'post',
        data,
    });
}
// 菜谱分类：删除
export function cookbookCategoryDelete(id) {
    return request({
        url: `/recipe/category/delete/${id}`,
        method: 'delete',
    });
}
// 菜谱分类：启用
export function cookbookCategoryEnable(id) {
    return request({
        url: `/recipe/category/enable/${id}`,
        method: 'post',
    });
}
// 菜谱分类：启用
export function cookbookCategoryDisable(id) {
    return request({
        url: `/recipe/category/disable/${id}`,
        method: 'post',
    });
}

// 菜谱标签：新增
export function cookbookLabelAdd(data) {
    return request({
        url: `/recipe/label/add`,
        method: 'post',
        data,
    });
}
// 菜谱标签：列表
export function cookbookLabelList() {
    return request({
        url: `/recipe/label/list`,
        method: 'get',
    });
}
// 菜谱标签：启用列表
export function cookbookLabelEnableList() {
    return request({
        url: `/recipe/label/enable/list`,
        method: 'get',
    });
}
// 菜谱标签：详情
export function cookbookLabelDetail(id) {
    return request({
        url: `/recipe/category/detail/${id}`,
        method: 'get',
    });
}
// 菜谱标签：更新
export function cookbookLabelUpdate(id, data) {
    return request({
        url: `/recipe/label/update/${id}`,
        method: 'post',
        data,
    });
}
// 菜谱标签：删除
export function cookbookLabelDelete(id) {
    return request({
        url: `/recipe/label/delete/${id}`,
        method: 'delete',
    });
}
// 菜谱标签：启用
export function cookbookLabelEnable(id) {
    return request({
        url: `/recipe/label/enable/${id}`,
        method: 'post',
    });
}
// 菜谱标签：禁用
export function cookbookLabelDisable(id) {
    return request({
        url: `/recipe/label/disable/${id}`,
        method: 'post',
    });
}

// 适用人群：新增
export function cookbookCrowdAdd(data) {
    return request({
        url: `/suitable/crowd/add`,
        method: 'post',
        data,
    });
}
// 适用人群：列表
export function cookbookCrowdList() {
    return request({
        url: `/suitable/crowd/list`,
        method: 'get',
    });
}
// 适用人群：启用列表
export function cookbookCrowdEnableList() {
    return request({
        url: `/suitable/crowd/enable/list`,
        method: 'get',
    });
}
// 适用人群：更新
export function cookbookCrowdUpdate(id, data) {
    return request({
        url: `/suitable/crowd/update/${id}`,
        method: 'post',
        data,
    });
}
// 适用人群：删除
export function cookbookCrowdDelete(id) {
    return request({
        url: `/suitable/crowd/delete/${id}`,
        method: 'delete',
    });
}
// 适用人群：启用
export function cookbookCrowdEnable(id) {
    return request({
        url: `/suitable/crowd/enable/${id}`,
        method: 'post',
    });
}
// 适用人群：禁用
export function cookbookCrowdDisable(id) {
    return request({
        url: `/suitable/crowd/disable/${id}`,
        method: 'post',
    });
}

// 餐次：新增
export function cookbookMealAdd(data) {
    return request({
        url: `/meal/times/add`,
        method: 'post',
        data,
    });
}
// 餐次：列表
export function cookbookMealList() {
    return request({
        url: `/meal/times/list`,
        method: 'get',
    });
}
// 餐次：启用列表
export function cookbookMealEnableList() {
    return request({
        url: `/meal/times/enable/list`,
        method: 'get',
    });
}
// 餐次：更新
export function cookbookMealUpdate(id, data) {
    return request({
        url: `/meal/times/update/${id}`,
        method: 'post',
        data,
    });
}
// 餐次：删除
export function cookbookMealDelete(id) {
    return request({
        url: `/meal/times/delete/${id}`,
        method: 'delete',
    });
}
// 餐次：启用
export function cookbookMealEnable(id) {
    return request({
        url: `/meal/times/enable/${id}`,
        method: 'post',
    });
}
// 餐次：禁用
export function cookbookMealDisable(id) {
    return request({
        url: `/meal/times/disable/${id}`,
        method: 'post',
    });
}

// 菜谱：新增
export function recipeAdd(data) {
    return request({
        url: `/recipe/add`,
        method: 'post',
        data,
    });
}
// 菜谱：分页
export function recipePage(data) {
    return request({
        url: `/recipe/page`,
        method: 'post',
        data,
    });
}
// 菜谱：详情
export function recipeDetail(id) {
    return request({
        url: `/recipe/detail/${id}`,
        method: 'get',
    });
}
// 菜谱：菜谱id获取关联列表
export function recipeIdGoodsList(cookbookId) {
    return request({
        url: `/recipe/goods/associated/list/${cookbookId}`,
        method: 'get',
    });
}
// 菜谱：更新
export function recipeUpdate(id, data) {
    return request({
        url: `/recipe/update/${id}`,
        method: 'post',
        data,
    });
}
// 菜谱：删除
export function recipeDelete(id) {
    return request({
        url: `/recipe/delete/${id}`,
        method: 'delete',
    });
}
// 菜谱：判断本地菜谱中是否存在
export function recipeCopy(id) {
    return request({
        url: `/recipe/is/copy/judgement/${id}`,
        method: 'get',
    });
}

// 套餐标签：新增
export function thaliLableAdd(data) {
    return request({
        url: `/set/meal/label/add`,
        method: 'post',
        data,
    });
}
// 套餐标签：列表
export function thaliLableList() {
    return request({
        url: `/set/meal/label/list`,
        method: 'get',
    });
}
// 套餐标签：启用列表
export function thaliLableEnableList() {
    return request({
        url: `/set/meal/label/enable/list`,
        method: 'get',
    });
}
// 套餐标签：更新
export function thaliLableUpdate(id, data) {
    return request({
        url: `/set/meal/label/update/${id}`,
        method: 'post',
        data,
    });
}
// 套餐标签：删除
export function thailLabelDelete(id) {
    return request({
        url: `/set/meal/label/delete/${id}`,
        method: 'delete',
    });
}
// 套餐标签：启用
export function thailLabelEnable(id) {
    return request({
        url: `/set/meal/label/enable/${id}`,
        method: 'post',
    });
}
// 套餐标签：禁用
export function thailLabelDisable(id) {
    return request({
        url: `/set/meal/label/disable/${id}`,
        method: 'post',
    });
}

// 本地套餐：新增
export function thaliAdd(data) {
    return request({
        url: `/set/meal/add`,
        method: 'post',
        data,
    });
}
// 本地套餐：分页
export function thaliPage(data) {
    return request({
        url: `/set/meal/page`,
        method: 'post',
        data,
    });
}
// 本地套餐：详情
export function thaliDetail(id) {
    return request({
        url: `/set/meal/detail/${id}`,
        method: 'get',
    });
}
// 本地套餐：更新
export function thaliUpdate(id, data) {
    return request({
        url: `/set/meal/update/${id}`,
        method: 'post',
        data,
    });
}
// 本地套餐：获取关联菜谱
export function thaliLinkCookbook(id) {
    return request({
        url: `/set/meal/recipe/associated/list/${id}`,
        method: 'get',
    });
}
// 本地套餐：删除
export function thaliDelete(id) {
    return request({
        url: `/set/meal/delete/${id}`,
        method: 'delete',
    });
}
// 套餐：是否复制
export function thaliCopy(id) {
    return request({
        url: `/set/meal/is/copy/judgement/${id}`,
        method: 'get',
    });
}

// 周食谱：根据日期获取周数据
export function weeklyByDate(data) {
    return request({
        url: `/weekly/menu/get/week/data/by/date`,
        method: 'post',
        data,
    });
}
// 周食谱：新增
export function weeklyAdd(data) {
    return request({
        url: `/weekly/menu/add`,
        method: 'post',
        data,
    });
}
// 周食谱：分页
export function weeklyPage(data) {
    return request({
        url: `/weekly/menu/page`,
        method: 'post',
        data,
    });
}
// 周食谱：详情
export function weeklyDetail(id) {
    return request({
        url: `/weekly/menu/detail/${id}`,
        method: 'get',
    });
}
// 周食谱：更新
export function weeklyUpdate(id, data) {
    return request({
        url: `/weekly/menu/update/${id}`,
        method: 'post',
        data,
    });
}
// 周食谱：删除
export function weeklyDelete(id) {
    return request({
        url: `/weekly/menu/delete/${id}`,
        method: 'delete',
    });
}
// 周食谱：配置列表
export function weeklyConfigList(weeklyMenuId) {
    return request({
        url: `/weekly/menu/config/list/${weeklyMenuId}`,
        method: 'get',
    });
}

// 食物分类汇总：类型列表
export function foodCategorySummaryList() {
    return request({
        url: `/food/category/summary/type/list`,
        method: 'post',
    });
}
// 食物分类汇总：新增
export function foodCategorySummaryAdd(data) {
    return request({
        url: `/food/category/summary/add`,
        method: 'post',
        data,
    });
}
// 食物分类汇总：分页列表
export function foodCategorySummaryPage(type) {
    return request({
        url: `/food/category/summary/list/by/type/${type}`,
        method: 'get',
    });
}
// 食物分类汇总：详情
export function foodCategorySummaryDetail(id) {
    return request({
        url: `/food/category/summary/detail/${id}`,
        method: 'get',
    });
}
// 食物分类汇总：更新
export function foodCategorySummaryUpdate(id, data) {
    return request({
        url: `/food/category/summary/update/${id}`,
        method: 'post',
        data,
    });
}
// 食物分类汇总：删除
export function foodCategorySummaryDelete(id) {
    return request({
        url: `/food/category/summary/delete/${id}`,
        method: 'delete',
    });
}

// 分析标准：营养素列表
export function analysisNutritionList() {
    return request({
        url: `/analysis/nutrition/list`,
        method: 'get',
    });
}
// 分析标准：新增
export function analysisMeasureAdd(data) {
    return request({
        url: `/analysis/measure/add`,
        method: 'post',
        data,
    });
}
// 分析标准：树
export function analysisMeasureTree(data) {
    return request({
        url: `/analysis/measure/tree`,
        method: 'post',
        data,
    });
}
// 分析标准：详情
export function analysisMeasureDetail(id) {
    return request({
        url: `/analysis/measure/detail/${id}`,
        method: 'get',
    });
}
// 分析标准：更新
export function analysisMeasureUpdate(id, data) {
    return request({
        url: `/analysis/measure/update/${id}`,
        method: 'post',
        data,
    });
}
// 分析标准：删除
export function analysisMeasureDelete(id) {
    return request({
        url: `/analysis/measure/delete/${id}`,
        method: 'delete',
    });
}
// 分析标准：启用
export function analysisMeasureEnable(id) {
    return request({
        url: `/analysis/measure/enable/${id}`,
        method: 'post',
    });
}
// 分析标准：禁用
export function analysisMeasureDisable(id) {
    return request({
        url: `/analysis/measure/disable/${id}`,
        method: 'post',
    });
}

// 分析配置：更新
export function analysisConfigUpdate(data) {
    return request({
        url: `/analysis/config/update`,
        method: 'post',
        data,
    });
}
// 分析配置：详情
export function analysisConfigDetail() {
    return request({
        url: `/analysis/config/info`,
        method: 'get',
    });
}

// 评价：新增
export function evaluationAdd(data) {
    return request({
        url: `/evaluation/add`,
        method: 'post',
        data,
    });
}
// 评价：分页
export function evaluationPage(data) {
    return request({
        url: `/evaluation/page`,
        method: 'post',
        data,
    });
}
// 评价：详情
export function evaluationDetail(id) {
    return request({
        url: `/evaluation/detail/${id}`,
        method: 'get',
    });
}
// 评价：编辑
export function evaluationUpdate(id, data) {
    return request({
        url: `/evaluation/update/${id}`,
        method: 'post',
        data,
    });
}
// 评价：删除
export function evaluationDelete(id) {
    return request({
        url: `/evaluation/delete/${id}`,
        method: 'delete',
    });
}

// APK: 最新版本
export function apkVersionNewest() {
    return request({
        url: `/apk/version/newest`,
        method: 'get',
    });
}
// APK: 发布版本
export function apkVersionRelease(data) {
    return request({
        url: `/apk/version/release`,
        method: 'post',
        data,
    });
}
// APK: 分页
export function apkVersionPage(data) {
    return request({
        url: `/apk/version/page`,
        method: 'post',
        data,
    });
}
// APK: 详情
export function apkVersionDetail(id) {
    return request({
        url: `/apk/version/detail/${id}`,
        method: 'get',
    });
}

// 营养标签：信息
export function nutritionLabelInfo() {
    return request({
        url: `/nutrition/label/setting/info`,
        method: 'get',
    });
}
// 营养标签：设置信息
export function nutritionLabelUpdate(data) {
    return request({
        url: `/nutrition/label/setting/update`,
        method: 'post',
        data,
    });
}

// 分析：食物种类
export function analysisFoodKind(data) {
    return request({
        url: `/analysis/food/kind`,
        method: 'post',
        data,
    });
}
// 分析：分析营养素
export function analysisNutrition(data) {
    return request({
        url: `/analysis/nutrition`,
        method: 'post',
        data,
    });
}
// 分析：能量
export function analysisEnergySource(data) {
    return request({
        url: `/analysis/energy/source`,
        method: 'post',
        data,
    });
}
// 分析：蛋白质来源
export function analysisProteinSource(data) {
    return request({
        url: `/analysis/protein/source`,
        method: 'post',
        data,
    });
}
// 分析：餐次
export function analysisMeal(data) {
    return request({
        url: `/analysis/meal/times/energy`,
        method: 'post',
        data,
    });
}

// 库存入库：新增
export function inventoryEntryAdd(data) {
    return request({
        url: `/inventory/entry/add`,
        method: 'post',
        data,
    });
}
// 库存入库：分页
export function inventoryEntryPage(data) {
    return request({
        url: `/inventory/entry/page`,
        method: 'post',
        data,
    });
}
// 库存入库：详情
export function inventoryEntryDetail(id) {
    return request({
        url: `/inventory/entry/detail/${id}`,
        method: 'get',
    });
}
// 库存入库：删除
export function inventoryEntryDelete(id) {
    return request({
        url: `/inventory/entry/delete/${id}`,
        method: 'delete',
    });
}
// 库存入库：更新
export function inventoryEntryUpdate(id, data) {
    return request({
        url: `/inventory/entry/update/${id}`,
        method: 'post',
        data,
    });
}

// 库存出库：新增
export function inventoryOutAdd(data) {
    return request({
        url: `/inventory/out/add`,
        method: 'post',
        data,
    });
}
// 库存出库：分页
export function inventoryOutPage(data) {
    return request({
        url: `/inventory/out/page`,
        method: 'post',
        data,
    });
}
// 库存出库：详情
export function inventoryOutDetail(id) {
    return request({
        url: `/inventory/out/detail/${id}`,
        method: 'get',
    });
}
// 库存出库：删除
export function inventoryOutDelete(id) {
    return request({
        url: `/inventory/out/delete/${id}`,
        method: 'delete',
    });
}
// 库存出库：更新
export function inventoryOutUpdate(id, data) {
    return request({
        url: `/inventory/out/update/${id}`,
        method: 'post',
        data,
    });
}

// 库存盘点：新增
export function inventoryCheckAdd(data) {
    return request({
        url: `/inventory/check/add`,
        method: 'post',
        data,
    });
}
// 库存盘点：分页
export function inventoryCheckPage(data) {
    return request({
        url: `/inventory/check/page`,
        method: 'post',
        data,
    });
}
// 库存盘点：详情
export function inventoryCheckDetail(id) {
    return request({
        url: `/inventory/check/detail/${id}`,
        method: 'get',
    });
}
// 库存盘点：删除
export function inventoryCheckDelete(id) {
    return request({
        url: `/inventory/check/delete/${id}`,
        method: 'delete',
    });
}
// 库存盘点：更新
export function inventoryCheckUpdate(id, data) {
    return request({
        url: `/inventory/check/update/${id}`,
        method: 'post',
        data,
    });
}

// 库存：综合查询
export function inventoryComprehensiveQuery(data) {
    return request({
        url: `/inventory/query/page/comprehensive/data`,
        method: 'post',
        data,
    });
}
// 库存：历史查询
export function inventoryHistoryQuery(data) {
    return request({
        url: `/inventory/query/list/history/data`,
        method: 'post',
        data,
    });
}

// 计算器：获取配置列表
export function calculatorConfigList() {
    return request({
        url: `/calculator/nutrition/recommend/config/list`,
        method: 'get',
    });
}
// 计算器：新增
export function calculatorConfigAdd(data) {
    return request({
        url: `/calculator/nutrition/recommend/config/detail/add`,
        method: 'post',
        data,
    });
}
// 计算器：详情列表
export function calculatorConfigDetail(calculatorNutritionConfigId) {
    return request({
        url: `/calculator/nutrition/recommend/config/detail/list/${calculatorNutritionConfigId}`,
        method: 'get',
    });
}
// 计算器：删除
export function calculatorConfigDelete(calculatorNutritionConfigId) {
    return request({
        url: `/calculator/nutrition/recommend/config/detail/delete/${calculatorNutritionConfigId}`,
        method: 'delete',
    });
}
// 计算器：更新
export function calculatorConfigUpdate(calculatorNutritionConfigId, data) {
    return request({
        url: `/calculator/nutrition/recommend/config/detail/update/${calculatorNutritionConfigId}`,
        method: 'post',
        data,
    });
}
// 计算器：推荐配置
export function calculatorConfigRecommend() {
    return request({
        url: `/calculator/nutrition/recommend/config/full/data`,
        method: 'get',
    });
}

// 驾驶舱评价：获取评价统计数据
export function getStatisticData() {
    return request({
        url: `/cockpit/evaluation/get/statistic/data`,
        method: 'get',
    });
}
// 驾驶舱评价：获取最新评价
export function getRateList(queryNumber) {
    return request({
        url: `/cockpit/evaluation/newest/evaluation/list/${queryNumber}`,
        method: 'get',
    });
}

// 大屏：最新周食谱
export function nutritionLabelWeekly(unitId) {
    return request({
        url: `/nutrition/label/latest/weekly/menu/by/unit/${unitId}`,
        method: 'get',
    });
}
// 大屏：根据周食谱id获取周食谱
export function nutritionLabelByWeeklyId(weeklyMenuId) {
    return request({
        url: `/nutrition/label/weekly/menu/by/id/${weeklyMenuId}`,
        method: 'get',
    });
}
// 大屏：通过单位id获取周食谱标签
export function weeklyLabelByUnitId(unitId) {
    return request({
        url: `/nutrition/label/weekly/menu/by/unit/${unitId}`,
        method: 'get',
    });
}
// 大屏：周食谱本地预览
export function weeklyLabelPreview(weeklyMenuId) {
    return request({
        url: `/nutrition/label/weekly/menu/by/id/${weeklyMenuId}`,
        method: 'get',
    });
}

// 营养看板（单位）: 基础数据
export function unitBaseData() {
    return request({
        url: `/cockpit/nutrition/get/unit/basic/data`,
        method: 'get',
    });
}
// 营养看板（单位）: 热门数据
export function unitHotData() {
    return request({
        url: `/cockpit/nutrition/get/unit/hot/data`,
        method: 'get',
    });
}
// 营养看板（单位）: 满意度数据
export function unitEvaluationData() {
    return request({
        url: `/cockpit/nutrition/get/unit/evaluation/data`,
        method: 'get',
    });
}
// 营养看板（单位）: 今日食谱数据
export function unitTodayData() {
    return request({
        url: `/cockpit/nutrition/get/unit/today/menu/data`,
        method: 'get',
    });
}

// 营养看板（平台）: 基础数据
export function platformBaseData() {
    return request({
        url: `/cockpit/nutrition/get/platform/basic/data`,
        method: 'get',
    });
}
// 营养看板（平台）: 热门数据
export function platformHotData() {
    return request({
        url: `/cockpit/nutrition/get/platform/hot/data`,
        method: 'get',
    });
}
// 营养看板（平台）: 满意度数据
export function platformEvaluationData() {
    return request({
        url: `/cockpit/nutrition/get/platform/evaluation/data`,
        method: 'get',
    });
}
// 营养看板（平台）: 今日食谱数据
export function platformTodayData() {
    return request({
        url: `/cockpit/nutrition/get/platform/today/menu/data`,
        method: 'get',
    });
}

// 点餐设置：分页
export function orderMealPage(data) {
    return request({
        url: `/order/meal/page`,
        method: 'post',
        data,
    });
}
// 点餐设置：关联
export function orderMealSetting(data) {
    return request({
        url: `/order/meal/setting`,
        method: 'post',
        data,
    });
}
